import { useEffect, useState, useRef } from "react";
import { RefreshComponet } from "../utility/UserDetails";
import { formatDate } from "../utility/dateUtils";
import {
  Tabs,
  Row,
  Input,
  Button,
  Tooltip,
  Card,
  Col,
  Checkbox,
  Modal,
  Empty,
  Select,
  Spin,
  Typography,
  Badge,
  Tag,
  Form,
  TimePicker
} from "antd";
import {
  EyeFilled,
  DiffOutlined,
  ExclamationCircleFilled,
  EditOutlined,
  CloseOutlined,
  SearchOutlined, ProfileOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { message as messageApi } from 'antd';
import AxiosInstance from "../services/axiosInstance";
import * as moment from "moment";
import { Toaster } from "../utility/Toaster";
import VoiceInput from "../components/reuseable/VoiceInput";
import InfiniteScroll from "react-infinite-scroll-component";
import SignatureModal from './home/Cli-Emp-Signatures';
import { Divider } from "antd";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ChangeRequestModal from "./HistoryModal/ChangeRequestModal";
import { Translate, translateApi } from "../utility/LanguagePopup";


const { TabPane } = Tabs;
const { Meta } = Card;
const Option = Select.Option;
const { Title } = Typography;
const { confirm } = Modal;
const History = () => {
  const displayItems = JSON.parse(localStorage.getItem('History_Screen'));
  const selectedDropdowns = JSON.parse(localStorage.getItem('selectedDropdowns') || '[]');
  console.log(selectedDropdowns, "selectedDropdowns")
  const { t } = useTranslation();
  const location = useLocation();
  const token = localStorage.getItem("rType");
  const [rType, setRType] = useState(token || '');
  const inputRef = useRef(null);
  let tabb = "";
  if (location.state !== null && location.state !== undefined && location?.state) {
    if (location?.state?.missingSignData == "Client Missing Signature") {
      tabb = "3"
    } else if (location?.state?.missingSignData == "Missing Signature") {
      tabb = "2"
    } else tabb = "1";
  } else tabb = "1";
  console.log(tabb, "tabb")
  const [activeTab, setActiveTab] = useState(tabb);
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChangeRequestModalOpen, setIsChangeRequestModalOpen] = useState(false);
  const [editSchDataModalOpen, setEditSchDataModalOpen] = useState(false);
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [taskData, setTaskData] = useState([]);
  const [outcomeData, setOutcomeData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [note, setNote] = useState(""); // State to store the note value
  const [notifySupervisor, setNotifySupervisor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payPeriod, setPayPeriod] = useState(false);
  const [warningLoading, setWarningLoading] = useState(false);
  const [Id, setIdForClickOnIcon] = useState([]);
  const [showTask, setShowTask] = useState(false);
  const [showOutcomes, setShowOutcomes] = useState(false);
  const [checkClientArry, setcheckClientArry] = useState([])
  const [selectAllActive, setSelectAllActive] = useState(true);
  //Drop down States
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  //infinite scroll state
  const [hasMore, setHasMore] = useState(true);
  const [pageNo, setPage] = useState(1);
  const [totalItem, setTotalItem] = useState("");
  const uType = localStorage.getItem("type");
  //signature modal
  const [showEmployeeSignature, setShowEmployeeSignature] = useState(false);
  const [showClientSignature, setShowClientSignature] = useState(false);

  const clientSigCanvas = useRef();
  const [userType, setUserType] = useState(null);

  // Edit Schedule Bottom Sheet refs and states
  const [editSchData, setEditSchData] = useState({
    sTime: dayjs().format("h:mm A"),
    eTime: dayjs().format("h:mm A"),
    reason: "",
    id: "",
    tasks: [],
    selectedTask: [],
  });

  // ✅ Normalize into internal structure (only keep "history" screen)
  let fields = selectedDropdowns
    .filter(d => d?.screen === 'history')
    .map(d => ({
      _id: d._id,
      type: d.type,
      value: d.value,      // e.g. 'sTime' | 'eTime' | 'tasks' | 'reason'
      label: d.label,      // e.g. 'Start time'
      required: !!d.required,
    }));

  // ✅ Move 'reason' to the bottom
  fields.sort((a, b) => (a.value === "reason" ? 1 : b.value === "reason" ? -1 : 0));

  const [form] = Form.useForm();

  // submit the form when user clicks OK/Update
  const handleEditOk = () => form.submit();

  // receive validated values, normalize, then call your original submit
  const handleFinish = (values) => {

    const s = values?.sTime;
    const e = values?.eTime;
    if (s && e && !dayjs(e).isAfter(s)) {
      messageApi.error("End time must be greater than start time");
      return;
    }

    const payload = {
      id: editSchData?.id,
      sTime: values?.sTime ? dayjs(values.sTime).format("hh:mm A") : undefined,
      eTime: values?.eTime ? dayjs(values.eTime).format("hh:mm A") : undefined,
      tasks: values?.tasks || [],
      reason: values?.reason?.trim(),
    };
    editScheduleSubmit(payload);
  };

  // only Reason is required
  const renderField = (field) => {
    const isReason = field.value === "reason";
    const rules = isReason ? [{ required: true, whitespace: true, message: `${field.label} is required` }] : [];

    switch (field.value) {
      case "sTime":
      case "eTime":
        return (
          <Form.Item key={field._id} name={field.value} label={field.label} >
            <TimePicker format="hh:mm A" style={{ width: "100%" }} needConfirm={false} />
          </Form.Item>
        );
      case "tasks":
        return (
          <>
            {/* ✅ Conditionally show Tasks field */}
            {Array.isArray(editSchData?.tasks) && editSchData.tasks.length > 0 && (
              <Form.Item name="tasks" label="Tasks">
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Select task(s)"
                  options={editSchData.tasks.map((t) => ({
                    label: <Translate value={t} />,
                    value: t,
                  }))}
                />
              </Form.Item>
            )}
          </>


        );
      case "reason":
        return (
          <Form.Item key={field._id} name="reason" label={field.label} rules={rules}>
            <VoiceInput as="textarea" rows={3} placeholder="Enter reason..." />
          </Form.Item>
        );
      default:
        return (
          <Form.Item key={field._id} name={field.value} label={field.label} rules={rules}>
            <Input />
          </Form.Item>
        );
    }
  };



  // useEffect(() => {
  //   fetchHistoryData(pageNo);
  // }, [activeTab]);

  // const fetchMoreData = () => {
  //   setPage(pageNo + 1); // Increment page number
  // };

  // useEffect(() => {
  //   if (pageNo > 1) {
  //     fetchHistoryData(pageNo); // Fetch items when page number changes
  //   }
  // }, [pageNo]); // Fetch items when page number changes

  // 🔹 When tab changes -> reset and load first page
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setHistoryData([]);
    fetchHistoryData(1);
  }, [activeTab, payPeriod]);

  // 🔹 InfiniteScroll: safe functional update
  const fetchMoreData = () => {
    if (!loading && hasMore) {
      setPage((prev) => prev + 1);     // ✅ no stale pageNo
    }
  };

  // 🔹 When pageNo changes (from scroll) -> load more
  useEffect(() => {
    if (pageNo > 1) {
      fetchHistoryData(pageNo);
    }
  }, [pageNo]);

  // 🔹 For your "refresh" flows (notes, signatures, filters)
  useEffect(() => {
    if (shouldFetchData) {
      setShouldFetchData(false);
      setPage(1);
      setHasMore(true);
      setHistoryData([]);
      fetchHistoryData(1);
    }
  }, [shouldFetchData]);





  useEffect(() => {
    if (shouldFetchData) {
      setShouldFetchData(false);
      fetchHistoryData(1);
    }
  }, [shouldFetchData]);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    if (userInfo) {
      setUserType(userInfo.type);
    }
  }, []);

  const fetchHistoryData = async (pageNo) => {
    fetchClient();
    setLoading(true);
    try {
      let User_Type = JSON.parse(localStorage.getItem("USER_INFO"));
      let endPoint = { e: "emp/time-card", c: "client/timecard" };
      let local = User_Type.type ? endPoint[User_Type.type] : "";
      // const URL = "emp/time-card";
      const page = pageNo;
      const itemPerPage = 20;
      let params = { page, itemPerPage };
      if (location.state !== null && location.state !== undefined && location.state.missingSignData) {
        const missingSignatures = location.state.missingSignData;
        if (missingSignatures == 'Client Missing Signature') {
          //  setActiveTab("3")
          if (User_Type.type === "e") {
            params.scheduleStatus = "Finished";
          } else {
            params.status = "Finished";
          }
          location.state = null
        }
        else {
          if (User_Type.type === "e") {
            setActiveTab("2")
            params.scheduleStatus = "Ended";
          } else {
            params.status = "Finished";
          }
          location.state = null
        }
      }
      else {
        if (activeTab == "2") {
          if (User_Type.type === "e") {
            params.scheduleStatus = "Ended";
          } else {
            params.status = "Finished";
          }
          // params.scheduleStatus = "Ended";
          if (selectedClient && selectedClient !== "all") {
            params.clientId = selectedClient;
          }
        } else if (activeTab == "3") {
          if (User_Type.type === "e") {
            params.scheduleStatus = "Finished";
          } else {
            params.status = "Finished";
          }
          if (selectedClient && selectedClient !== "all") {
            params.clientId = selectedClient;
          }
        }

      }




      const updatedParams = {
        ...params,
        payPeriod: payPeriod,
      };
      const response = await AxiosInstance.get(local, {
        params: updatedParams,
      });
      if (response.data.dirtyBit) RefreshComponet(response.data.dirtyBit)
      const res = response.data.data;

      setLoading(false);
      if (res && res.rows && Array.isArray(res.rows)) {
        res.rows.forEach((x) => {
          //x.duration = 'N/A';
          if (x.aSTime && x.aETime) {
            let start = moment.utc(x.aSTime, "HH:mm A");
            let end = moment.utc(x.aETime, "HH:mm A");
            let d = moment.duration(end.diff(start));
            let time = d["_data"];
            x.duration = time.hours + ":" + time.minutes;
          } else {
            if (x.sTime && x.eTime) {
              let start = moment.utc(x.sTime, "HH:mm A");
              let end = moment.utc(x.eTime, "HH:mm A");
              let d = moment.duration(end.diff(start));
              let time = d["_data"];
              x.duration = time.hours + ":" + time.minutes;
            }
          }
        });

        setTotalItem(res.pagination.size);
        setLoading(false);

        // setHistoryData((prevItems) => [...prevItems, ...res.rows]);
        // if (res.rows.length === 0) {
        //   setHasMore(false);
        // }

        if (pageNo === 1) {
          // first page (new tab / refreshed) -> replace
          setHistoryData(res.rows);
        } else {
          // next pages -> append
          setHistoryData((prevItems) => [...prevItems, ...res.rows]);
        }

        // if less than page size, no more data
        if (res.rows.length < itemPerPage) {
          setHasMore(false);
        }


        setSelectAllActive(true)
      } else {
        // // console.error("Unexpected data format:", res);
        setLoading(false);
        setHasMore(false); // Stop processing if data format is unexpected
      }
    } catch (error) {
      setLoading(false);
      // // console.error("Error fetching history data:", error);
    }
  };


  const getColor = (c) => {
    switch (c.scheduleStatus) {
      case "New":
        return "teal";
      case "Completed":
        return "rgb(50, 205, 50)";
      case "Ended":
        return "#808080";
      case "Cancelled":
        return "#FF0000";
      case "Inprogress":
        return "#F2AA4CFF";
      case "Finished":
        return "#13c2c2";
      case "Unverified":
        return "#000000";
      default:
        return "#1E90FF";
    }
  };

  const fetchClient = async () => {
    try {
      const URL = "/emp/my-client";
      const response = await AxiosInstance.get(URL);
      const res = response.data;
      if (res.success) {
        setClients(res.data);
      }
    } catch (error) {
      // // console.error("Error fetching history data:", error);
    }
  };

  const handleTabClick = (key) => {
    setActiveTab(key);
    setPayPeriod(false);
    resetState();
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        // Remove the ID if it's already selected
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        // Add the ID if it's not selected
        return [...prevSelectedIds, id];
      }
    });
  };
  // // console.log(historyData, 'historydaya')


  const allArrayAreEqual = () => {
    const result = checkClientArry.every(element => {
      if (element === checkClientArry[0]) {
        return true;
      }
    });
    return result;
  }
  const handleSelectAll = () => {
    const allIds = historyData.map((item) => item._id);
    setSelectedIds(allIds); // Update selectedIds with all IDs from data
    setSelectAllActive(false); // Hide "Select All" button
  };

  const handleDeselectAll = () => {
    setSelectedIds([]);
    setSelectAllActive(true); // Hide "Deselect All" button
  };

  const handleOk = async () => {
    // noteToTranslate is the original note that user entered (in their language) and translatedNote is what we will send to backend (translated to English if needed)
    setLoading(true);
    const language = localStorage.getItem("language");
    const noteToTranslate = note || "";
    const translatedNote = language && language !== "en" ? await translateApi(note, "en", language, true) : noteToTranslate;
    let obj = { ids: [], note: translatedNote, notifySupervisor: notifySupervisor, originalNote: noteToTranslate };
    if (selectedIds.length > 0) {
      obj.ids = selectedIds;
    } else {
      obj.ids = [Id];
    }

    if (!note) {
      Toaster("error", "Error", "Please fill the note field");
      setLoading(false);
      return;
    }
    const URL = "emp/attach-note-schedules";
    AxiosInstance.put(URL, obj)
      .then(({ data }) => {
        if (data.success) {
          Toaster("success", "Success", data?.message);
          setSelectedIds([]);
          setHistoryData([]);
          setIsModalOpen(false);
          setLoading(false);
          setNotifySupervisor(false)
          setIdForClickOnIcon([]);
          setShouldFetchData(true);
        } else {
          // // console.log(data.message);
        }
      })
      .catch((err) => {
        // // console.log(err);
        Toaster("error", "Error", err?.response?.data?.message);
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    setNote(e.target.value); // Update the note value as the user types
  };

  const handleNotifySupervisor = () => {
    setNotifySupervisor((prev) => !prev); // Toggle boolean value
  };

  const handleCopy = () => {
    const textarea = document.createElement("textarea");
    textarea.textContent = note;
    document.body.append(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    Toaster("success", "Copied", "Text copied successfully");
  };
  const showModal = () => {
    setIsModalOpen(true);
    setNote("");
  };
  const showChangeRequestModal = () => {
    setIsChangeRequestModalOpen(true);
  };
  const openSignatureModal = (selectedIds) => {
    const array = historyData.filter(item => selectedIds.includes(item._id)).map(item => item.clientId?._id)
    setcheckClientArry(array);
    if (activeTab === '2') {
      if (userType === "e") setShowEmployeeSignature(true);
      else setShowClientSignature(true);
    }
    else if (activeTab === '3') {
      const schedule = historyData[0];
      if (schedule?.cSignService) showModalClientPin(selectedIds);
      else setShowClientSignature(true);
    }
  };

  const getEmpSignature = (URL) => {
    const eSign = URL
    employeeSignature(eSign);
  };
  const getClientSignature = (URL) => {
    const cSign = URL
    clientSignature(cSign);
  };

  const employeeSignature = async (employeeSig) => {
    try {
      setLoading(true);
      if (selectedIds.length === 0) {
        return;
      }
      const endpoint = { e: "emp/multiple-schedule", c: "client/multi-sign" };
      let User_Type = JSON.parse(localStorage.getItem("USER_INFO"));
      let local = User_Type.type ? endpoint[User_Type.type] : '';
      const signatureData = {
        ids: selectedIds,
        eSign: employeeSig,
      };

      AxiosInstance.post(local, signatureData)
        .then(({ data }) => {

          if (data.success) {
            if (User_Type.type === 'e') {
              const duplicate = allArrayAreEqual();
              if (!duplicate && (User_Type.type === "e" && !checkClientArry.length)) {
                setHistoryData([])
                this.toastCtrl.presentToast(this.translate.instant(data.message));
                Toaster("success", data.message, "");
              } else {
                setShowEmployeeSignature(false)
                ClientSignAlert(selectedIds[0], data.data.cSignService);
                //    else{
                //     if(data.data.cSignService && data.data.cSig)
                //     setHistoryData([])
                //     fetchHistoryData(1);
                //     // this.toastCtrl.presentToast(this.translate.instant(data.message));
                //     Toaster("success", data.message, "");
                //    }
              }
            } else {
              setHistoryData([])
            }

          } else {
            Toaster("error", data.message, "");
            // this.toastCtrl.errorToast("ATTENTION", data.message);// this.toastCtrl.presentToast(this.translate.instant(res.message));
          }
        })
        .catch((err) => {
          // // console.log(err);
          Toaster("error", "Error", err.response.data.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      // // console.error(error);
    }
  };

  const ClientSignAlert = (id, isService, dir = "") => {
    let schedule;
    if (dir) schedule = historyData.filter(x => x._id == id)[0];
    if (schedule) isService = schedule.cSignService || false;
    if (historyData.length !== 0) {
      let dup = allArrayAreEqual();
      if (dup) {
        if (isService) showModalClientPin(id);
        else setShowClientSignature(true);

      } else {
        Toaster("error", "Please select same client for signatures", "");
        // this.toastCtrl.presentToast("Please select same client for signatures");
        setHistoryData([])
        // this.checkClientArry = [];
        // historyData.map(x => {
        //   x.isChecked = false;
        // });
      }
    }
  }

  const clientSignature = (clientSig) => {
    // // console.log(selectedClient, "test test test")
    setWarningLoading(true);
    let local = 'emp/client-multi-sign';
    let signatureData = {
      ids: selectedIds,
      cSign: clientSig,
      clientId: checkClientArry[0]
    }
    if (rType == "rp") signatureData.rp = 'rp';
    AxiosInstance.post(local, signatureData)
      .then(({ data }) => {
        setWarningLoading(false);
        if (data.success) {
          setShowClientSignature(false);
          Toaster("success", "Success", data.message);
          setSelectedIds([]);
          setHistoryData([]);
          setIsModalOpen(false);
          setLoading(false);
          setIdForClickOnIcon([]);
          setShouldFetchData(true);
        } else {
          Toaster("info", "ATTENTION", data.message);
        }
      })
      .catch((err) => {
        // // console.log(err);
        Toaster("error", "Error", err.message);
        setWarningLoading(false);
      });
  }




  const showModalClientPin = (dataId) => {
    confirm({
      title: t('Do you want client signature? Please enter client signature pin'),
      icon: <ExclamationCircleFilled />,
      content: (
        <Input
          placeholder={t("Enter PIN")} maxLength={5}
          ref={inputRef}
        />
      ),
      onOk: () => {
        setWarningLoading(true);
        const pinValue = inputRef.current?.input.value.trim();
        if (pinValue) {
          let endPoint = { e: 'emp/verify-pin', c: 'client/verify-pin' };
          let User_Type = JSON.parse(localStorage.getItem("USER_INFO"));
          let local = User_Type.type ? endPoint[User_Type.type] : '';
          let obj = {
            id: Array.isArray(dataId) ? dataId[0] : dataId,
            // id: dataId,
            pin: pinValue
          };
          AxiosInstance.post(local, obj)
            .then(({ data }) => {
              setWarningLoading(false);
              if (data.success) {
                messageApi.success(data.message);
                setShowClientSignature(true);
                // setShouldFetchData(true)
              } else {
                messageApi.error(data.message);
                showModalClientPin(dataId); // Show modal again if there's an error
              }
            })
            .catch((err) => {
              // // console.error(err);
              messageApi.error(err.message);
              setWarningLoading(false);
            });
        } else {
          messageApi.error('Please enter a PIN');
          setWarningLoading(false);
          showModalClientPin(dataId);
        }

      },
      onCancel() {
        setSelectedIds([]);
        setHistoryData([]);
        setIsModalOpen(false);
        setLoading(false);
        setIdForClickOnIcon([]);
        setShouldFetchData(true);
      },
    });
  };

  const showNoteModal = async (item) => {
    setLoading(true);
    const note = item?.notes ? item?.notes[0]?.note : "";
    const language = await localStorage.getItem("language");
    const translatedNote = note !== "" && language && language !== "en" ? await translateApi(note, language, "en", true) : note;
    setIsModalOpen(true);
    setNote(translatedNote);
    setIdForClickOnIcon(item._id);
    setNotifySupervisor(item.notifySupervisor);
    setLoading(false);
  };

  useEffect(() => {
    if (!editSchDataModalOpen) return;
    form.setFieldsValue({
      sTime: editSchData?.sTime ? dayjs(editSchData.sTime, "hh:mm A") : undefined,
      eTime: editSchData?.eTime ? dayjs(editSchData.eTime, "hh:mm A") : undefined,
      tasks: editSchData?.selectedTask ?? [],
      reason: editSchData?.reason ?? "",
    });
  }, [editSchDataModalOpen, editSchData, form]);


  const showEditScheduleModal = (item) => {
    console.log("Edit Schedule Clicked", item);
    setEditSchDataModalOpen(true);
    setEditSchData((prev) => {
      const tasks = Array.isArray(item?.tasks) ? item.tasks : [];
      return {
        ...prev,
        sTime: item?.aSTime ?? item?.sTime ?? prev.sTime,
        eTime: item?.aETime ?? item?.eTime ?? prev.eTime,
        id: item?._id ?? "",
        tasks,
        selectedTask: tasks?.length ? [...tasks] : [], // select only the initial tasks
      };
    });

    if (Array.isArray(item?.tasks) || !item?.tasks) {
      getSchServices(item?._id);
    }
  }

  const getSchServices = (_id) => {
    setLoading(true);
    const url = `emp/careplan-service?schedule_id=${_id}`;
    AxiosInstance.get(url)
      .then((res) => {
        setLoading(false);
        if (res.data.success && res.data?.data?.careplan?.length) {
          const apiTasks = res.data.data.careplan.map(x => x.task);

          setEditSchData((prev) => {
            // keep original order: first existing tasks, then new ones
            const existing = prev.tasks || [];
            const newOnes = apiTasks.filter(t => !existing.includes(t));
            const merged = [...existing, ...newOnes];

            // keep current selections; if none yet, select ONLY the existing (pre-API) tasks
            const hadSelection = Array.isArray(prev.selectedTask) && prev.selectedTask.length > 0;
            const kept = hadSelection
              ? prev.selectedTask.filter((t) => merged.includes(t))  // drop selections for removed items
              : [...existing];                                               // select only pre-API tasks by default

            return { ...prev, tasks: merged, selectedTask: kept };
          });
        }
      })
      .catch(() => setLoading(false));
  };

  const showTaskModal = (isCheck, item) => {
    setShowTask(isCheck);
    setTaskData(item);
  };
  const showOutcomesModal = (isCheck, item) => {
    debugger
    setShowOutcomes(isCheck);
    setOutcomeData(item);
  };
  const closeSignatureModal = () => {
    setSelectedIds([]);
    setHistoryData([]);
    setIsModalOpen(false);
    setLoading(false);
    setIdForClickOnIcon([]);
    setShouldFetchData(true);
    setShowEmployeeSignature(false);
    setShowClientSignature(false);
  }
  const handleCancel = () => {
    setShowTask(false);
    setShowOutcomes(false);
    setIsModalOpen(false);
    // setShowEmployeeSignature(false);
    setNote("");
    setNotifySupervisor(false)
    clientSigCanvas?.current?.clear();
  };

  const hideEditScheduleModal = () => {
    setEditSchDataModalOpen(false);
    setEditSchData({
      sTime: dayjs().format("h:mm A"),
      eTime: dayjs().format("h:mm A"),
      reason: "",
      id: "",
      tasks: [],
      selectedTask: [],
    });
    form.resetFields();
    // setEditSchData({});
  }

  // fields already built & sorted from selectedDropdownsList
  // fields: [{ value: 'sTime'|'eTime'|'sDate'|'tasks'|'reason', ... }]
  const selectedKeys = fields.map((f) => f.value); // -> ['sTime','reason'] etc.

  const editScheduleSubmit = async (formValues) => {
    setLoading(true);

    try {
      // Build only the selected fields from the *submitted form values*, not from editSchData
      const dynamicPart = selectedKeys.reduce((acc, key) => {
        if (key in formValues) acc[key] = formValues[key];
        return acc;
      }, {});

      // Determine tasks array (prefer form-submitted 'tasks', fall back to 'selectedTask', then state)
      const tasksFinal =
        Array.isArray(formValues?.tasks) ? formValues.tasks
          : Array.isArray(formValues?.selectedTask) ? formValues.selectedTask
            : Array.isArray(editSchData?.selectedTask) ? editSchData.selectedTask
              : [];

      // Validate "reason" ONLY if it's part of selectedKeys
      if (selectedKeys.includes("reason")) {
        const reasonVal = (dynamicPart?.reason ?? formValues?.reason ?? "").trim();
        if (!reasonVal) {
          messageApi.info("Please fill the reason field");
          setLoading(false);
          return;
        }
        // ensure reason present in dynamicPart (server expects it if key was selected)
        dynamicPart.reason = reasonVal;
      }

      const finalPayload = {
        id: formValues?.id ?? editSchData?.id, // always include id
        ...dynamicPart,                        // only selected fields
        tasks: tasksFinal,                     // send tasks as array
      };
      console.log("SUBMIT payload:", finalPayload);
      const URL = "emp/history-schedules";
      const { data } = await AxiosInstance.put(URL, finalPayload);

      if (data?.success) {
        hideEditScheduleModal();
        Toaster("success", "Success", data?.message);

        // reset selections/state as you had
        setSelectedIds([]);
        setHistoryData([]);
        setIdForClickOnIcon([]);
        setShouldFetchData(true);
      } else {
        if (data?.dailyHourLimit) {
          setLoading(false);
          // Toaster("error", data?.message);
          Modal.confirm({
            title: data?.message,
            confirmLoading: loading,
            icon: <ExclamationCircleFilled />,
            footer: (
              <div style={{ float: "inline-end" }}>
                <Button
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={() => Modal.destroyAll()}
                >
                  {t("OK")}
                </Button>
              </div>
            ),
          });
          return;
        }
        else {
          Modal.confirm({
            title: data?.message || "Update failed",
            confirmLoading: loading,
            icon: <ExclamationCircleFilled />,
            footer: (
              <div style={{ float: "inline-end" }}>
                <Button
                  key="submit"
                  type="primary"
                  loading={loading}
                  onClick={() => Modal.destroyAll()}
                >
                  {t("OK")}
                </Button>
              </div>
            ),
          });
          // messageApi.error(data?.message || "Update failed");
        }
      }
    } catch (err) {
      messageApi.error(err?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };



  const filteredHistoryData = historyData.filter(
    (item) =>
      item.clientId?.fName.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.clientId?.lName.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.scheduleStatus?.toLowerCase().includes(searchValue.toLowerCase())
    // item.scheduleStatus.toLowerCase().includes(searchValue.toLowerCase())
  );

  //in case of tabs change we reset all state null
  const resetState = () => {
    setHistoryData([]);
    setIsModalOpen(false);
    setShouldFetchData(false);
    setSearchValue("");
    setTaskData([]);
    setOutcomeData([]);
    setSelectedIds([]);
    setNote("");
    setLoading(false);
    setIdForClickOnIcon([]);
    setShowTask(false);
    setShowOutcomes(false);
    setShowEmployeeSignature(false);
    setClients([]);
    setSelectedClient("");
    setPage(1);
    setHasMore(true);        // ✅ IMPORTANT for InfiniteScroll
  };



  // drop down methods
  const onChange = (value) => {
    // if (value === "all") {
    //   // console.log(`All ${value}`);
    // } else {
    //   // console.log(`clientId: ${value}`);
    // }
    setHistoryData([]);
    setSelectedClient(value);
    setShouldFetchData(true);
  };
  //End drop methods
  return (
    <>
      <Spin
        spinning={warningLoading}
        size="large"
        fullscreen
        tip={t("FetchingYourData")}
      />
      <Tabs
        activeKey={activeTab}
        onChange={handleTabClick}
        left
        size="middle"
        type="card"
      >
        <TabPane
          tab={
            <div style={{ display: "flex", flexDirection: "column" }}>
              {/* <span>
                <CheckCircleOutlined />
              </span> */}
              <span>{t("All")}</span>
            </div>
          }
          key="1"
        >
          <Row
            gutter={[8, 0]}
            style={{
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            <Col
              span={6}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={displayItems.historyLabelNote ? 12 : 24}
            >
              <Input
                style={{ borderColor: "#91caff" }}
                size="small"
                placeholder={t("SearchByName")}
                prefix={<SearchOutlined className="site-form-item-icon" />}
                suffix={
                  // Conditional rendering of the cross icon
                  searchValue.length > 0 && (
                    <Button
                      type="link"
                      onClick={() => setSearchValue("")} // Clear search value
                      style={{ marginRight: 7, padding: 0 }}
                    >
                      <CloseOutlined />
                    </Button>
                  )
                }
                onChange={(e) => setSearchValue(e.target.value)}
                value={searchValue}
              />
            </Col>
            {/* {filteredHistoryData?.length !== 0 && ( */}
            <Col
              span={6}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={12}
              style={{ marginTop: 10 }}
            >
              {filteredHistoryData?.length !== 0 && (
                <>
                  {uType === "e" && selectAllActive &&
                    displayItems &&
                    displayItems.historyLabelNote &&
                    selectedIds?.length !== 0 && (
                      <Button
                        type="primary"
                        className="ant-btn-form"
                        onClick={showModal}
                        style={{
                          float: "inline-end",
                          backgroundColor: "#32CD32",
                        }}
                      >
                        {t("AddNote")}
                      </Button>
                    )}
                  {displayItems && (
                    <Button
                      type="primary"
                      className="ant-btn-form"
                      onClick={showChangeRequestModal}
                      style={{
                        float: "inline-end",
                        backgroundColor: "#43b4f5",
                        marginRight: "10px",
                      }}
                    >
                      {t("Change Request")}
                    </Button>
                  )}
                  {/* {selectedIds?.length !== 0 && */}
                  <>
                    {selectAllActive ? (
                      <Button
                        type="primary"
                        className="ant-btn-form"
                        onClick={handleSelectAll}
                        style={{ float: "inline-end", marginRight: "10px" }}
                      >
                        {t("Select All")}
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        danger
                        className="ant-btn-form"
                        onClick={handleDeselectAll}
                        style={{ float: "inline-end", marginRight: "10px" }}
                      >
                        {t("UnselectAll")}
                      </Button>
                    )}
                  </>
                </>
              )}
              {uType === "e" && (
                <Checkbox
                  checked={payPeriod}
                  onChange={(e) => setPayPeriod(e.target.checked)}
                  style={{ float: "inline-end", marginRight: "10px" }}
                >
                  Ongoing pay period
                </Checkbox>
              )}
              {/* } */}
            </Col>
            {/* )} */}
          </Row>

          {/* {filteredHistoryData.length !== 0 &&(
          <Col span={6} xs={24} sm={24} md={12} lg={6} xl={selectedIds?.length == 0  ? 4 : 2}>
            {selectAllActive ? (
                    <Button
                    type="primary"
                    className="ant-btn-form"
                      onClick={handleSelectAll}
                      style={{ float:'inline-end', marginLeft:'5' }}
                    >
                      <FormattedMessage id="Select All" />
                    </Button>
                  ) : (
                    <Button
                    type="primary"
                    className="ant-btn-form"
                      onClick={handleDeselectAll}
                      style={{ float:'inline-end' }}
                    >
                      <FormattedMessage id="DeselectAll" />
                    </Button>
                  )}
          </Col>
        )} */}

          {/* <Flex
            style={{
              marginBottom: "15px",
              padding: "10px",
              background: "#91caff",
            }}
            justify="space-between"
          >
            <Input
              style={{ width: "30%", borderRadius: "10px" }}
              size="small"
              placeholder="Search by name / Sch status"
              prefix={<SearchOutlined className="site-form-item-icon" />}
              suffix={
                // Conditional rendering of the cross icon
                searchValue.length > 0 && (
                  <Button
                    type="link"
                    onClick={() => setSearchValue("")} // Clear search value
                    style={{ marginRight: -7, padding: 0 }}
                  >
                    <CloseOutlined />
                  </Button>
                )
              }
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
            <span>
              {displayItems &&
              displayItems.historyLabelNote &&
              selectedIds?.length ? (
                <Button
                  type="link"
                  onClick={showModal}
                  style={{ color: "black" }}
                >
                  <FormattedMessage id="AddNote" />
                </Button>
              ) : null}

             

              {filteredHistoryData.length ? (
                <>
                  {selectAllActive ? (
                    <Button
                      type="link"
                      onClick={handleSelectAll}
                      style={{ color: "black" }}
                    >
                      <FormattedMessage id="Select All" />
                    </Button>
                  ) : (
                    <Button
                      type="link"
                      onClick={handleDeselectAll}
                      style={{ color: "red" }}
                    >
                      <FormattedMessage id="DeselectAll" />
                    </Button>
                  )}
                </>
              ) : null}
            </span>
          </Flex> */}
          {/* // Modal for editSchData  */}
          <InfiniteScroll
            dataLength={filteredHistoryData.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <>
                <Spin
                  spinning={loading}
                  size="large"
                  style={{ marginLeft: "45rem" }}
                />{" "}
                {t("LoadingMoreData")}
              </>
            }
            height={600}
            delay={500}
            endMessage={
              searchValue.length === 0 && filteredHistoryData.length ? (
                <Divider plain style={{ fontWeight: "bold" }}>
                  {" "}
                </Divider>
              ) : null
            }
          >
            <Spin
              spinning={loading}
              size="large"
              style={{ marginTop: "3rem" }}
            >
              <Row
                gutter={[16, 16]}
                className="mt-3"
                style={{ margin: "0px 0px" }}
              >
                {filteredHistoryData.map((item, index) => (
                  <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8}>
                    <Badge.Ribbon
                      placement="start"
                      text={t(item.scheduleStatus)}
                      color={getColor(item)}
                    >
                      <Card
                        style={{
                          background: "#f0f2f5",
                          borderLeftWidth: "3px",
                          borderLeftColor: getColor(item),
                          fontWeight: "bold",
                          position: "relative",
                          boxShadow: "none",
                        }}
                      >
                        <Meta
                          title={
                            <div style={{}}>
                              <div
                                style={{
                                  position: "absolute",
                                  right: "4px",
                                  top: "0.5rem",
                                }}
                              >
                                <Checkbox
                                  checked={selectedIds.includes(item._id)}
                                  onChange={() =>
                                    handleCheckboxChange(item._id)
                                  }
                                ></Checkbox>
                              </div>
                              <div
                                style={{
                                  marginTop: 33,
                                  marginLeft: "5px",
                                  marginBottom: 15,
                                }}
                              >
                                <div style={{ display: "flex", gap: 4, justifyContent: "space-between", paddingRight: 8 }}>
                                  <span>
                                    {formatDate(item?.eDate, 'MM/DD/YYYY')}
                                    {/* {dayjs(item?.eDate)
                                      .add(1, "day")
                                      .format("MM/DD/YYYY")} */}
                                  </span>
                                  <span style={{ display: "block", fontWeight: 600 }}>
                                    {formatDate(item?.eDate, 'DDDD')}
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    {" "}
                                    {item.aSTime || item.sTime} -{" "}
                                    {item.aETime || item.eTime}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "0.7rem",
                                      color: "#8546A7",
                                    }}
                                  >
                                    {" "}
                                    {item?.service?.desc}
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    {(item?.clientId && uType === "e") && (
                                      <span>
                                        {item?.clientId?.fName} {item?.clientId?.lName}
                                      </span>
                                    )}
                                    {(item?.empId && uType === "c") && (
                                      <span>
                                        {item?.empId?.fName} {item?.empId?.lName}
                                      </span>
                                    )}
                                    {/* {item.clientId.fName}{" "}
                                      {item.clientId.lName} */}
                                  </span>
                                </div>
                                <div>
                                  {" "}
                                  {t("Duration")} :
                                  <span style={{ color: "#8546A7" }}>
                                    { } {item.duration}
                                  </span>
                                  <span style={{ float: "inline-end" }}>
                                    {selectedDropdowns.length > 0 && (item?.bStatus === 'Non-Billed' || item?.bStatus === 'No UMPI' || item?.bStatus === 'No-SA') && (item?.scheduleStatus === "Completed" || item?.scheduleStatus === "Ended" || item?.scheduleStatus === "Finished") ? (
                                      <Tooltip title="Edit Schedule">
                                        <Tag
                                          style={{ cursor: "pointer" }}
                                          color="#2e5c1bff"
                                          onClick={() => showEditScheduleModal(item)}
                                        >
                                          {" "}
                                          <EditOutlined />
                                        </Tag>
                                      </Tooltip>
                                    ) : null}
                                  </span>
                                  <span style={{ float: "inline-end" }}>
                                    {item?.notes?.length > 0 ? (
                                      <Tooltip title="Add Note">
                                        <Tag
                                          style={{ cursor: "pointer" }}
                                          color="#87d068"
                                          onClick={() => showNoteModal(item)}
                                        >
                                          {" "}
                                          <DiffOutlined />
                                        </Tag>
                                      </Tooltip>
                                    ) : null}
                                  </span>
                                  <span style={{ float: "inline-end" }}>
                                    {item?.tasks?.length ? (
                                      <Tooltip title="View Tasks">
                                        <Tag
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "4px",
                                          }}
                                          color="#2db7f5"
                                          onClick={() =>
                                            showTaskModal(true, item)
                                          }
                                        >
                                          <EyeFilled />
                                        </Tag>
                                      </Tooltip>
                                    ) : null}
                                    {item?.outcomes?.length ? (
                                      <Tooltip title="View Outcomes">
                                        <Tag
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "4px",
                                          }}
                                          color="#2db7f5"
                                          onClick={() =>
                                            showOutcomesModal(true, item)
                                          }
                                        >
                                          <ProfileOutlined />
                                        </Tag>
                                      </Tooltip>
                                    ) : null}
                                  </span>
                                </div>
                              </div>
                            </div>
                          }
                        />
                      </Card>
                    </Badge.Ribbon>
                  </Col>
                ))}
              </Row>
            </Spin>
            {filteredHistoryData.length === 0 && (
              <Empty
                style={{
                  marginTop: "10rem",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
                description={t("No Data Found")}
              />
            )}
          </InfiniteScroll>
        </TabPane>

        {displayItems && displayItems.historyTabEmpMissingSig && (
          <TabPane
            tab={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* <span>
                <StopOutlined />
              </span> */}
                <span> {t("Missing Signs")}</span>
              </div>
            }
            key="2"
          >
            <Row
              gutter={[8, 0]}
              style={{
                marginTop: 10,
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
              }}
            >
              {userType === "e" && (
                <Col
                  span={6}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={displayItems.historyLabelNote ? 12 : 24}
                >
                  <Select
                    size="large"
                    placeholder={t("Select Client")}
                    optionFilterProp="children"
                    onChange={onChange}
                    value={selectedClient !== "" ? selectedClient : undefined}
                    style={{ borderColor: "#91caff" }}
                  >
                    <Option key="all" value="all">
                      All
                    </Option>
                    {clients.map((item, index) => (
                      <Option key={index} value={item._id}>
                        {item?.fName} {item?.lName}
                      </Option>
                    ))}
                  </Select>
                </Col>
              )}
              {filteredHistoryData?.length !== 0 && userType === "c" ? (
                <Col span={6} xs={24} sm={24} md={12} lg={6} xl={12}></Col>
              ) : null}
              <Col
                span={6}
                xs={24}
                sm={24}
                md={12}
                lg={6}
                xl={12}
                style={{ marginTop: 10 }}
              >
                {uType === "e" && selectAllActive &&
                  displayItems &&
                  displayItems.historyLabelNote &&
                  selectedIds?.length !== 0 && (
                    <Button
                      type="primary"
                      className="ant-btn-form"
                      onClick={showModal}
                      style={{
                        float: "inline-end",
                        backgroundColor: "#32CD32",
                      }}
                    >
                      {t("AddNote")}
                    </Button>
                  )}
                {displayItems &&
                  displayItems.historyLabelAuthenticate &&
                  selectedIds?.length !== 0 && (
                    <Button
                      type="primary"
                      className="ant-btn-form"
                      style={{
                        float: "inline-end",
                        backgroundColor: "#00A5FF",
                        marginRight: "10px",
                      }}
                      onClick={() => openSignatureModal(selectedIds)}
                    >
                      {t("Authenticate")}
                    </Button>
                  )}
                {filteredHistoryData?.length !== 0 && (
                  <>
                    {selectAllActive ? (
                      <Button
                        type="primary"
                        className="ant-btn-form"
                        onClick={handleSelectAll}
                        style={{ float: "right", marginRight: "10px" }}
                      >
                        {t("Select All")}
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        className="ant-btn-form"
                        danger
                        onClick={handleDeselectAll}
                        style={{ float: "inline-end", marginRight: "10px" }}
                      >
                        {t("UnselectAll")}
                      </Button>
                    )}
                  </>
                )}
                {/* <Checkbox
                  checked={payPeriod}
                  onChange={(e) => setPayPeriod(e.target.checked)}
                  style={{ float: "inline-end", marginRight: "10px" }}
                >
                  Ongoing pay period
                </Checkbox> */}
                {/* } */}
              </Col>
            </Row>

            <InfiniteScroll
              dataLength={filteredHistoryData.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={
                <>
                  <Spin
                    spinning={loading}
                    size="large"
                    style={{ marginLeft: "45rem" }}
                  />{" "}
                  {t("LoadingMoreData")}
                </>
              }
              height={600}
              endMessage={
                filteredHistoryData.length ? (
                  <Divider plain style={{ fontWeight: "bold" }}>
                    {""}
                  </Divider>
                ) : null
              }
            >
              <Spin
                spinning={loading}
                size="large"
                style={{ marginTop: "3rem" }}
              >
                <Row
                  gutter={[16, 16]}
                  className="mt-3"
                  style={{ margin: "0px 0px" }}
                >
                  {filteredHistoryData.map((item, index) => (
                    <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8}>
                      <Badge.Ribbon
                        placement="start"
                        text={t(item.scheduleStatus)}
                        color={getColor(item)}
                      >
                        <Card
                          style={{
                            background: "#f0f2f5",
                            borderLeftWidth: "3px",
                            borderLeftColor: getColor(item),
                            fontWeight: "bold",
                            position: "relative",
                            boxShadow: "none",
                          }}
                        >
                          <Meta
                            title={
                              <div style={{}}>
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "4px",
                                    top: "0.5rem",
                                  }}
                                >
                                  <Checkbox
                                    checked={selectedIds.includes(item._id)}
                                    onChange={() =>
                                      handleCheckboxChange(item._id)
                                    }
                                  ></Checkbox>
                                </div>
                                <div
                                  style={{
                                    marginTop: 33,
                                    marginLeft: "5px",
                                    marginBottom: 10,
                                  }}
                                >
                                  <div style={{ display: "flex", gap: 4, justifyContent: "space-between", paddingRight: 8 }}>
                                    <span>
                                      {formatDate(item?.eDate, 'MM/DD/YYYY')}
                                      {/* {dayjs(item?.eDate)
                                        .add(1, "day")
                                        .format("MM/DD/YYYY")} */}
                                    </span>
                                    <span style={{ display: "block", fontWeight: 600 }}>
                                      {formatDate(item?.eDate, 'DDDD')}
                                    </span>
                                  </div>
                                  <div>
                                    <span>
                                      {" "}
                                      {item.aSTime || item.sTime} -{" "}
                                      {item.aETime || item.eTime}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "0.7rem",
                                        color: "#8546A7",
                                      }}
                                    >
                                      {" "}
                                      {item?.service?.desc}
                                    </span>
                                  </div>
                                  <div>
                                    {(item?.clientId && uType === "e") && (
                                      <span>
                                        {item?.clientId?.fName} {item?.clientId?.lName}
                                      </span>
                                    )}
                                    {(item?.empId && uType === "c") && (
                                      <span>
                                        {item?.empId?.fName} {item?.empId?.lName}
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    {t("Duration")}
                                    <span style={{ color: "#8546A7" }}>
                                      { } {item.duration}
                                    </span>
                                    <span style={{ float: "inline-end" }}>
                                      {selectedDropdowns.length > 0 && (item?.bStatus === 'Non-Billed' || item?.bStatus === 'No UMPI' || item?.bStatus === 'No-SA') && (item?.scheduleStatus === "Completed" || item?.scheduleStatus === "Ended" || item?.scheduleStatus === "Finished") ? (
                                        <Tooltip title="Edit Schedule">
                                          <Tag
                                            style={{ cursor: "pointer" }}
                                            color="#2e5c1bff"
                                            onClick={() => showEditScheduleModal(item)}
                                          >
                                            {" "}
                                            <EditOutlined />
                                          </Tag>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                    <span style={{ float: "inline-end" }}>
                                      {item?.notes?.length > 0 ? (
                                        <Tooltip title="Add Note">
                                          <Tag
                                            style={{ cursor: "pointer" }}
                                            color="#87d068"
                                            onClick={() =>
                                              showNoteModal(item)
                                            }
                                          >
                                            {" "}
                                            <DiffOutlined />
                                          </Tag>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                    <span style={{ float: "inline-end" }}>
                                      {item?.tasks?.length ? (
                                        <Tooltip title="View Tasks">
                                          <Tag
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "4px",
                                            }}
                                            color="#2db7f5"
                                            onClick={() =>
                                              showTaskModal(true, item)
                                            }
                                          >
                                            <EyeFilled />
                                          </Tag>
                                        </Tooltip>
                                      ) : null}
                                      {item?.outcomes?.length ? (
                                        <Tooltip title="View OutComes">
                                          <Tag
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "4px",
                                            }}
                                            color="#2db7f5"
                                            onClick={() =>
                                              showOutcomesModal(true, item)
                                            }
                                          >
                                            <ProfileOutlined />
                                          </Tag>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            }
                          />
                        </Card>
                      </Badge.Ribbon>
                    </Col>
                  ))}
                </Row>
              </Spin>
              {filteredHistoryData.length === 0 && (
                <Empty
                  style={{
                    marginTop: "10rem",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                  description={t("No Data Found")}
                />
              )}
            </InfiniteScroll>
          </TabPane>
        )}

        {userType === "e" &&
          displayItems &&
          displayItems.historyTabClientMissingSig && (
            <TabPane
              tab={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* <span>
                <CloseCircleOutlined />
              </span> */}
                  <span> {t("Client Missing Signs")}</span>
                </div>
              }
              key="3"
            >
              <Row
                gutter={[8, 0]}
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                }}
              >
                {userType === "e" && (
                  <Col
                    span={6}
                    xs={24}
                    sm={24}
                    md={12}
                    lg={6}
                    xl={displayItems.historyLabelNote ? 12 : 24}
                  >
                    <Select
                      size="large"
                      placeholder={t("Select Client")}
                      optionFilterProp="children"
                      onChange={onChange}
                      value={
                        selectedClient !== "" ? selectedClient : undefined
                      }
                      style={{ borderColor: "#91caff" }}
                    >
                      <Option key="all" value="all">
                        All
                      </Option>
                      {clients.map((item, index) => (
                        <Option key={index} value={item._id}>
                          {item?.fName} {item?.lName}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                )}

                {/* {filteredHistoryData?.length !== 0 && ( */}
                <Col
                  span={6}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={12}
                  style={{ marginTop: 10 }}
                >
                  {filteredHistoryData?.length !== 0 && (
                    <>
                      {userType === "e" && selectAllActive &&
                        displayItems &&
                        displayItems.historyLabelNote &&
                        selectedIds?.length !== 0 && (
                          <Button
                            type="primary"
                            className="ant-btn-form"
                            onClick={showModal}
                            style={{
                              float: "inline-end",
                              backgroundColor: "#32CD32",
                            }}
                          >
                            {t("AddNote")}
                          </Button>
                        )}
                      {displayItems &&
                        displayItems.historyLabelAuthenticate &&
                        selectedIds?.length !== 0 && (
                          <Button
                            type="primary"
                            className="ant-btn-form"
                            style={{
                              float: "inline-end",
                              backgroundColor: "#00A5FF",
                              marginRight: "10px",
                            }}
                            onClick={() => openSignatureModal(selectedIds)}
                          >
                            {t("Authenticate")}
                          </Button>
                        )}
                      {/* {selectedIds?.length !== 0 && */}
                      <>
                        {selectAllActive ? (
                          <Button
                            type="primary"
                            className="ant-btn-form"
                            onClick={handleSelectAll}
                            style={{ float: "inline-end", marginRight: "10px" }}
                          >
                            {t("Select All")}
                          </Button>
                        ) : (
                          <Button
                            type="primary"
                            className="ant-btn-form"
                            danger
                            onClick={handleDeselectAll}
                            style={{ float: "inline-end", marginRight: "10px" }}
                          >
                            {t("UnselectAll")}
                          </Button>
                        )}
                      </>
                    </>
                  )}
                  {/* <Checkbox
                    checked={payPeriod}
                    onChange={(e) => setPayPeriod(e.target.checked)}
                    style={{ float: "inline-end", marginRight: "10px" }}
                  >
                    Ongoing pay period
                  </Checkbox> */}
                  {/* } */}
                </Col>
                {/* )} */}
              </Row>

              <InfiniteScroll
                dataLength={filteredHistoryData.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={
                  <>
                    <Spin
                      spinning={loading}
                      size="large"
                      style={{ marginLeft: "45rem" }}
                    />{" "}
                    {t("LoadingMoreData")}
                  </>
                }
                height={600}
                endMessage={
                  filteredHistoryData.length ? (
                    <Divider plain style={{ fontWeight: "bold" }}>
                      {""}
                    </Divider>
                  ) : null
                }
              >
                <Spin
                  spinning={loading}
                  size="large"
                  style={{ marginTop: "3rem" }} v
                >
                  <Row
                    gutter={[16, 16]}
                    className="mt-3"
                    style={{ margin: "0px 0px" }}
                  >
                    {filteredHistoryData.map((item, index) => (
                      <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8}>
                        <Badge.Ribbon
                          placement="start"
                          text={t(item.scheduleStatus)}
                          color={getColor(item)}
                        >
                          <Card
                            style={{
                              background: "#f0f2f5",
                              borderLeftWidth: "3px",
                              borderLeftColor: getColor(item),
                              fontWeight: "bold",
                              position: "relative",
                              boxShadow: "none",
                            }}
                          >
                            <Meta
                              title={
                                <div style={{}}>
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "4px",
                                      top: "0.5rem",
                                    }}
                                  >
                                    <Checkbox
                                      checked={selectedIds.includes(item._id)}
                                      onChange={() =>
                                        handleCheckboxChange(item._id)
                                      }
                                    ></Checkbox>
                                  </div>
                                  <div
                                    style={{
                                      marginTop: 33,
                                      marginLeft: "5px",
                                      marginBottom: 10,
                                    }}
                                  >
                                    <div style={{ display: "flex", gap: 4, justifyContent: "space-between", paddingRight: 8 }}>
                                      <span>
                                        {formatDate(item?.eDate, 'MM/DD/YYYY')}
                                        {/* {dayjs(item?.eDate)
                                          .add(1, "day")
                                          .format("MM/DD/YYYY")} */}
                                      </span>
                                      <span style={{ display: "block", fontWeight: 600 }}>
                                        {formatDate(item?.eDate, 'DDDD')}
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        {" "}
                                        {item?.aSTime || item?.sTime} -{" "}
                                        {item?.aETime || item?.eTime}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.7rem",
                                          color: "#8546A7",
                                        }}
                                      >
                                        {" "}
                                        {item?.service?.desc}
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        {item?.clientId?.fName}{" "}
                                        {item?.clientId?.lName}
                                      </span>
                                    </div>
                                    <div>
                                      {t("Duration")}
                                      <span style={{ color: "#8546A7" }}>
                                        { } {item.duration}
                                      </span>
                                      <span style={{ float: "inline-end" }}>
                                        {selectedDropdowns.length > 0 && (item?.bStatus === 'Non-Billed' || item?.bStatus === 'No UMPI' || item?.bStatus === 'No-SA') && (item?.scheduleStatus === "Completed" || item?.scheduleStatus === "Ended" || item?.scheduleStatus === "Finished") ? (
                                          <Tooltip title="Edit Schedule">
                                            <Tag
                                              style={{ cursor: "pointer" }}
                                              color="#2e5c1bff"
                                              onClick={() => showEditScheduleModal(item)}
                                            >
                                              {" "}
                                              <EditOutlined />
                                            </Tag>
                                          </Tooltip>
                                        ) : null}
                                      </span>
                                      <span style={{ float: "inline-end" }}>
                                        {item?.notes?.length > 0 ? (
                                          <Tooltip title="Add Note">
                                            <Tag
                                              style={{ cursor: "pointer" }}
                                              color="#87d068"
                                              onClick={() =>
                                                showNoteModal(item)
                                              }
                                            >
                                              {" "}
                                              <DiffOutlined />
                                            </Tag>
                                          </Tooltip>
                                        ) : null}
                                      </span>
                                      <span style={{ float: "inline-end" }}>
                                        {item?.tasks?.length ? (
                                          <Tooltip title="View Tasks">
                                            <Tag
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "4px",
                                              }}
                                              color="#2db7f5"
                                              onClick={() =>
                                                showTaskModal(true, item)
                                              }
                                            >
                                              <EyeFilled />
                                            </Tag>
                                          </Tooltip>
                                        ) : null}
                                        {item?.outcomes?.length ? (
                                          <Tooltip title="View Outcomes">
                                            <Tag
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "4px",
                                              }}
                                              color="#2db7f5"
                                              onClick={() =>
                                                showOutcomesModal(true, item)
                                              }
                                            >
                                              <ProfileOutlined />
                                            </Tag>
                                          </Tooltip>
                                        ) : null}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              }
                            />
                          </Card>
                        </Badge.Ribbon>
                      </Col>
                    ))}
                  </Row>
                </Spin>
                {filteredHistoryData.length === 0 && (
                  <Empty
                    style={{
                      marginTop: "10rem",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                    description={t("No Data Found")}
                  />
                )}
              </InfiniteScroll>
            </TabPane>
          )}
      </Tabs>
      <Modal
        title={t("Schedule Change Request")}
        open={editSchDataModalOpen}
        onOk={handleEditOk}                         // ✅ submit form
        onCancel={hideEditScheduleModal}
        closable={false}
        footer={[
          <Button
            danger
            type="primary"
            key="cancel"
            onClick={hideEditScheduleModal}
            className="ant-btn-modal"
          >
            {t("Cancel")}
          </Button>,
          <Button
            key="update"
            type="primary"
            style={{ marginTop: "2rem" }}   // ✅ removed trailing ';'
            className="ant-btn-modal"
            onClick={handleEditOk}                  // ✅ submit form
            loading={loading}
          >
            {t("Submit")}
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            sTime: editSchData?.sTime ? dayjs(editSchData.sTime, "HH:mm") : undefined,
            eTime: editSchData?.eTime ? dayjs(editSchData.eTime, "HH:mm") : undefined,
            tasks: Array.isArray(editSchData?.selectedTask) ? editSchData.selectedTask : [],
            reason: editSchData?.reason ?? "",
          }}
        >
          {fields.map(renderField)}
        </Form>
      </Modal>

      <ChangeRequestModal
        open={isChangeRequestModalOpen}
        onClose={() => setIsChangeRequestModalOpen(false)}
        title={t("Request Status")}
      />

      {/* Modal for end to schedules */}

      <Modal
        title={"Add Note To Schedules"}
        open={isModalOpen}
        // width={"50%"}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            danger
            type="primary"
            key="cancel"
            style={{
              marginTop: "2rem",
              padding: "0 11rem;",
            }}
            onClick={handleCancel}
            className="ant-btn-modal"
          >
            {t("Cancel")}
          </Button>,
          userType === 'e' && (
            <Button
              key="update"
              type="primary"
              style={{
                marginTop: "2rem",
                padding: "0 11rem;",
              }}
              className="ant-btn-modal"
              onClick={handleOk}
              loading={loading}
            >
              {t("Update")}
            </Button>
          ),
          note ? (
            <Button
              key="copy"
              type="primary"
              className="ant-btn-modal"
              onClick={handleCopy}
              style={{
                marginTop: "2rem",
                padding: "0 11rem;",
              }}
            >
              {t("Copy")}
            </Button>
          ) : null,
        ]}
      >
        <div>
          <VoiceInput
            as="textarea"
            showCount
            maxLength={700}
            onChange={handleChange}
            value={note}
            disabled={userType !== 'e'}
            placeholder={userType === 'e' ? t("Enter your note here") : t("No notes added for this schedule")}
            style={{ width: "100%" }}
          />
        </div>
        {userType === 'e' ?
          <div style={{ marginTop: '5px' }}>
            <Checkbox
              checked={notifySupervisor}
              onChange={handleNotifySupervisor}
              style={{ fontWeight: "normal" }}
            >
              {t("Notify Supervisor")}
            </Checkbox>
          </div> : null}
        {/* </Space> */}
      </Modal>


      <Modal
        title=""
        open={showTask}
        // width={"50%"}
        // onOk={handleOk}
        onCancel={handleCancel}
        closable={true}
        footer={null}
      > <h4>Tasks</h4>
        {/* <Space direction="horizontal"> */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "space-evenly",
          }}
        >

          {taskData?.tasks?.map((item, index) => (
            <Card
              key={index}
              style={{
                width: 300,
                padding: "13px",
                fontSize: "medium",
                background: "#f4f4f4",
                boxShadow: "#f1f1f1 0px -2px",
              }}
            >
              {/* <span>{item.split(":")[0]}</span> */}
              <span>
                <Translate value={item.split(":").slice(0, 2).join(": ")} />
              </span>
            </Card>
          ))}
          {/* </Space> */}
        </div>
      </Modal>
      <Modal
        title=""
        open={showOutcomes}
        // width={"50%"}
        // onOk={handleOk}
        onCancel={handleCancel}
        closable={true}
        footer={null}
      ><h4>OutComes</h4>
        {/* <Space direction="horizontal"> */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "space-evenly",
          }}
        >
          {outcomeData?.outcomes?.map((item, index) => (
            <Card
              key={index}
              style={{
                width: 300,
                padding: "13px",
                fontSize: "medium",
                background: "#f4f4f4",
                boxShadow: "#f1f1f1 0px -2px",
              }}
            >
              {/* <span>{item.split(":")[0]}</span> */}
              <span>
                <Translate value={item} />
              </span>
            </Card>
          ))}
          {/* </Space> */}
        </div>
      </Modal>
      {showEmployeeSignature && (
        <SignatureModal
          showSignature={showEmployeeSignature}
          handleCancel={closeSignatureModal}
          type="employee"
          loading={warningLoading}
          onDone={getEmpSignature} // Pass the callback function from the parent component
        />
      )}
      {showClientSignature && (
        <SignatureModal
          showSignature={showClientSignature}
          handleCancel={closeSignatureModal}
          type={rType === "rp" ? "rp" : "client"}
          loading={warningLoading}
          onDone={getClientSignature} // Pass the callback function from the parent component
        />
      )}
    </>
  );
};

export default History;
